import { Component, HostBinding, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { PopUpManager, WizDatasource, WizIcon, WizPopUp  } from '@wizeoo/akm-component-lib';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { ArgEditorData } from '../../freedatas/renderers/args.renderer';
import { FreedataFieldSettingsPop, FreedataFieldSettingsPopVO, FreedataFieldSettingsResult } from './../../freedataform/pops/freedata-field-settings.pop';
import { Model } from '../../../../model/model';
import { SmallArgsRenderer } from './smallargs.renderer';



@Component({
  selector: 'freedata-tile-gridster-item',
  templateUrl:'./freedata-tile-gridster-item.component.html'
})
export class FreedataTileGridsterItem {
  @HostBinding('class') classes = 'freedata-gridster-item';

  @ViewChild('argRender') argRender: SmallArgsRenderer; // le rendu
  @ViewChild('icoSettings') icoSettings: WizIcon; // icone de conf

  private _gridsterItem: GridsterWidgetItem; // l'objet de conf



  argData: ArgEditorData;

  _field: PivotField;
  _freeDataValueVO: FreedataValueVO;
  _templatingMode: boolean = false;

  @Input() model: Model;

  // la collection source
  @Input() provider: WizDatasource<any> = null;


  @Input() set templatingMode(value: boolean) {
    this._templatingMode = value;
  }


  @Input() set freedataValue(fdv: FreedataValueVO) {
    this._freeDataValueVO = fdv;
    this.feedData();
  }

  @Input() set field(value: GridsterWidgetItem) {
    this._field = value.field as PivotField;
    this._gridsterItem = value;
    // console.log('set field...', this._field);
    this.feedData();
  }

  private feedData(): void {
    this.argData = {
      model: this.model,
      arg: this._field.arg,
      fdv: this._freeDataValueVO,
      context: this._gridsterItem,
      provider: this.provider
    };
  }

  @Output() delete = new EventEmitter<GridsterWidgetItem>();

  onDeleteClick() {
    this.delete.emit(this._gridsterItem);
  }

  protected fieldPop: WizPopUp; // la popUp d'édition des champs

  /** clic sur l'icone de conf */
  public onSettings(): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( FreedataFieldSettingsPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataFieldSettingsPop.baseWidth + 'px',
      FreedataFieldSettingsPop.baseHeight + 'px');

    // construction des données
    const datas: FreedataFieldSettingsPopVO = {
      model: this.model,
      argData: this.argData,
      context: this._gridsterItem,
      updateCallback: this.backFromFieldPop.bind(this),
    }

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour de popUp de configuration
   * @param field champ à afficher
   * @param showLabel affichage ou pas du label
   * @param label le lable
   * @param format désiré
   * @param ro: readOnly
   */
  public backFromFieldPop(result: FreedataFieldSettingsResult): void {
    this._gridsterItem.subField = result.field;
    this._gridsterItem.source.subField = result.field;
    const fdf: PivotField = this._gridsterItem.field as PivotField;
    fdf.contextItem.slbl = result.showLabel;
    fdf.contextItem.lbl = result.label;
    fdf.contextItem.fmt = result.format || null;
    fdf.contextItem.ro = !!result.ro;
    fdf.contextItem.subField = result.field;
    fdf.contextItem.fdvSearch = result.fdvSearch || null;
    fdf.contextItem.sty = result.style || null;
    fdf.contextItem.noc = !!result.noClone;
    fdf.contextItem.pgrp = result.pgrp || null;
    fdf.contextItem.pmdexParams = result.pmdexParams || null;
    this.argRender.feed();
  }

  /**
   * retour de popUp de configuration
   * @param field champ à afficher
   * @param showLabel affichage ou pas du label
   * @param label le lable
   * @param format désiré
   * @param ro: readOnly
   * @param fdvsearch false
   * @param sty: style custom
   */
  // protected backFromFieldPop(field: string, showLabel: boolean, label: string, format?: string, ro:boolean = false, fdvsearch: boolean = false, sty: string = null): void {
  //   // this._subField = result;
  //   this._gridsterItem.subField = field;
  //   this._gridsterItem.source.subField = field;
  //   const fdf: PivotField = this._gridsterItem.field as PivotField;
  //   fdf.contextItem.slbl = showLabel;
  //   fdf.contextItem.lbl = label;
  //   fdf.contextItem.fmt = format;
  //   fdf.contextItem.ro = ro;
  //   fdf.contextItem.sty = sty;
  //   // this.argData.arg.datas = result; // affectation du type pour refresh du argRenderer
  //   // console.log('back from field', field, showLabel);
  //   this.argRender.feed();
  // }

}
